<template>
  <div
    class="absolute right-3 top-3 flex flex-col gap-px overflow-hidden rounded-lg bg-bgr shadow-lg"
  >
    <button
      class="flex h-11 w-11 cursor-pointer items-center justify-center border-none bg-bgr text-txt transition-all duration-200 ease-in-out hover:text-thm"
      @click="toggle"
    >
      <WebccIcon
        class="h-5 w-5 text-txt-weak hover:text-thm"
        :name="
          isFullscreen ? 'searchpage/fullscreen-exit' : 'searchpage/fullscreen'
        "
      />
    </button>
  </div>
</template>

<script setup lang="ts">
import { useFullscreen } from '@vueuse/core'

const props = defineProps<{ map: google.maps.Map }>()

const emit = defineEmits<{
  fullscreenToggle: [isFullscreen: boolean]
}>()

const mapElement = computed(() => props.map?.getDiv() || null)
const { isFullscreen, toggle } = useFullscreen(mapElement, {
  autoExit: true,
})

watch(isFullscreen, (newValue) => {
  emit('fullscreenToggle', newValue)
})
</script>
